import React from 'react';
import { Button, Form } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import dynamic from 'next/dynamic';

const Editor = dynamic(() => import('react-draft-wysiwyg').then((mod) => mod.Editor), { ssr: false });

export default function CommentForm({
  editorState,
  onEditorStateChange,
  onSubmit,
  isSubmitting = false,
  isSubmitDisabled = false,
  formStyle,
  formItemStyle,
  wrapperStyle,
  editorStyle,
  buttonStyle,
  buttonIcon,
  leftAdornment,
  toolbar,
  toolbarHidden = false,
}) {
  return (
    <Form
      name='comment-form'
      labelCol={{ span: 0 }}
      wrapperCol={{ span: 24 }}
      style={formStyle}
      onFinish={onSubmit}
      autoComplete='off'
    >
      <div style={wrapperStyle || { position: 'relative' }}>
        {leftAdornment}
        <Form.Item label={false} style={formItemStyle}>
          <Editor
            editorStyle={editorStyle}
            editorState={editorState}
            toolbarClassName='toolbarClassName'
            wrapperClassName='wrapperClassName'
            editorClassName='editorClassName'
            onEditorStateChange={onEditorStateChange}
            toolbarHidden={toolbarHidden}
            toolbar={
              toolbar || {
                options: ['emoji', 'colorPicker', 'remove'],
                inline: { inDropdown: true },
                list: { inDropdown: true },
                textAlign: { inDropdown: true },
                link: { inDropdown: true },
                history: { inDropdown: true },
              }
            }

          />
        </Form.Item>
        <Button
          type='primary'
          htmlType='submit'
          disabled={isSubmitting || isSubmitDisabled}
          loading={isSubmitting}
          style={buttonStyle}
        >
          {buttonIcon || <SendOutlined />}
        </Button>
      </div>
    </Form>
  );
}
